import React, { useContext } from 'react';
import ThrottlingCheckbox from 'integrations/components/ThrottlingCheckbox';
import AdditionalFields from 'integrations/aws/common/AdditionalFields';

import { Input } from 'components/bootstrap';

import { FormDataContext } from './context/FormData';
import { AdvancedOptionsContext } from './context/AdvancedOptions';

type FormAdvancedOptionsProps = {
  onChange: (...args: any[]) => void;
};

const FormAdvancedOptions = ({ onChange }: FormAdvancedOptionsProps) => {
  const { formData } = useContext(FormDataContext);
  const { isAdvancedOptionsVisible, setAdvancedOptionsVisibility } = useContext(AdvancedOptionsContext);

  const { o365ThrottleEnabled, o365StoreFullMessage, timeoutGracePeriodMinutes } = formData;

  const handleToggle = (visible) => {
    setAdvancedOptionsVisibility(visible);
  };

  return (
    <AdditionalFields title="Advanced Options" visible={isAdvancedOptionsVisible} onToggle={handleToggle}>
      <ThrottlingCheckbox id="o365ThrottleEnabled" defaultChecked={o365ThrottleEnabled?.value} onChange={onChange} />

      <Input
        id="o365StoreFullMessage"
        type="checkbox"
        value="enable-storeFullMessage"
        defaultChecked={o365StoreFullMessage?.value}
        onChange={onChange}
        label="Store Full Message"
        help="Store the full original Office 365 log record message as full_message?"
      />

      <Input
        id="timeoutGracePeriodMinutes"
        type="number"
        min="1"
        value={timeoutGracePeriodMinutes?.value ?? ''}
        onChange={onChange}
        label="Timeout Grace Period (minutes)"
        help="How long repeated Office 365 timeouts must continue before the input is marked as failing."
      />
    </AdditionalFields>
  );
};

export default FormAdvancedOptions;
